import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DialogV2Service } from '@platform/dialog/dialog-v2.service';
import { MobileUploadQrDialogComponent } from '@core/mobile-upload/mobile-upload-qr-dialog/mobile-upload-qr-dialog.component';
import { DocumentLibraryMetaData } from '@apps/documents/document-library/document-library.model';
import { FileProcessService } from '@apps/file-process/file-process.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InboxDto } from '../../inbox/inbox.model';

@Component({
  selector: 'app-scan-document-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, TranslateModule],
  templateUrl: './scan-document-button.component.html',
  styleUrls: ['./scan-document-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScanDocumentButtonComponent {
  @Input({ required: true }) inbox: InboxDto;
  @Input({ required: true }) customerSpaceId: string;
  @Input() documentLibraryMetaData!: DocumentLibraryMetaData;
  @Input() iconOnly = false;
  @Output() mobileUploadDialogClosed = new EventEmitter();

  constructor(
    private dialogService: DialogV2Service,
    private fileProcessService: FileProcessService,
  ) {}

  public openMobileUploadDialog() {
    const dialog = this.dialogService.open(MobileUploadQrDialogComponent, {
      data: {
        customerSpaceId: this.customerSpaceId,
        locationName: '',
        createMobileUpload: () => this.fileProcessService.createMobileUploadForInbox(this.customerSpaceId, this.inbox),
      },
    });

    dialog.afterClosed().subscribe(() => this.mobileUploadDialogClosed.emit());
  }
}
